import Component from '../../common/Component';
import app from '../app';
import Link from '../../common/components/Link';
import CommentPost from './CommentPost';
export default class PostListItem extends Component {
  view() {
    const post = this.attrs.post;
    return m("div", {
      className: "PostListItem"
    }, m("div", {
      className: "PostListItem-discussion"
    }, app.translator.trans('core.forum.post_list.in_discussion_text', {
      discussion: m(Link, {
        href: app.route.post(post)
      }, post.discussion().title())
    })), m(CommentPost, {
      post: post,
      params: this.attrs.params
    }));
  }
}
flarum.reg.add('core', 'forum/components/PostListItem', PostListItem);